import { combineReducers } from 'redux';
import {
} from '../constants/ArtistsSearchConstants';

const ArtistsSearchReducer = () => {}

export default ArtistsSearchReducer;
